import { useState } from 'react';
import { Button } from 'antd';
import { useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { PageContent, Drawer } from 'components';
import { ListUsers, DetailUser } from '../components';

import { I18n } from 'i18n';

export function Users() {
  const history = useHistory();
  const [visible, setVisible] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>('');

  const onCloseDrawer = () => {
    setUserId('');
    setVisible(false);
  };

  const onShowDrawer = (value?: string) => {
    if (!value) return setVisible(true);
    setUserId(value);
    setVisible(true);
  };

  return (
    <PageContent
      title={I18n('list_users', true, true)}
      backIcon={false}
      extra={[
        <Button
          disabled={false}
          type="primary"
          className="rk-button-primary"
          onClick={() => history.push('/users/create')}
        >
          {I18n('add', true)}
        </Button>,
      ]}
    >
      <ListUsers onShowDrawer={onShowDrawer} />
      <Drawer
        showTitle={true}
        title={I18n('user_information', true, true)}
        placement="right"
        onClose={() => onCloseDrawer()}
        visible={visible}
        closeIcon={[
          <div style={{ display: 'flex', gap: 30 }}>
            {userId && (
              <Link to={`/users/${userId}`}>
                <div>{I18n('edit', true)}</div>
              </Link>
            )}
            <FontAwesomeIcon icon={faTimesCircle} />
          </div>,
        ]}
      >
        <DetailUser userId={userId} onCloseDrawer={onCloseDrawer} />
      </Drawer>
    </PageContent>
  );
}
